import { useEffect } from 'react'
import { fetchMoviesWithFallback } from '../utilities/fetchWithFallback'
import { useDispatch } from 'react-redux'
import { addPopularMovies } from '../utilities/movieSlice';

const usePopularMovies = () => {
    const dispatch=useDispatch();
  useEffect(()=>{
    const getPopularMovie= async ()=>{
        const results = await fetchMoviesWithFallback('https://api.themoviedb.org/3/movie/popular?page=1', 'popular');
        dispatch(addPopularMovies(results));
    }
    getPopularMovie()
  },[dispatch])
}

export default usePopularMovies;